class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.imgSrc1 = this.getAttribute('imgSrc1');
    this.imgSrc2 = this.getAttribute('imgSrc2');
    this.name = this.getAttribute('name');
    this.price = this.getAttribute('price');
    this.fullprice = this.getAttribute('fullprice');
    this.size = this.getAttribute('size');
    this.type = this.getAttribute('type');
    this.displayName = this.getAttribute('displayName');
    this._sku = this.getAttribute('sku');
    this.background = this.getAttribute('background');
    this.textcolor = this.getAttribute('textcolor');
    this.description = this.getAttribute('description');
    this.footnote = this.getAttribute('footnote');
    this._shippingDate = this.getAttribute('shippingDate');
    this.preorder = this.getAttribute('preorder');
    this.group = this.getAttribute('group');
    this.finalSale = this.getAttribute('finalSale');
    this._available = this.getAttribute('available');
    this.indexPage = this.getAttribute('indexPage');
    this.productType = this.getAttribute('productType');
    this.shopUrl = this.getAttribute('shopUrl');
    this.inventory = this.getAttribute('inventory');
    this.seller = this.getAttribute('seller').toLowerCase();
    this.strikeThrough = this.getAttribute('showStrike');
    this.coverVideo = this.getAttribute('coverVideo');
    this.renderCoverVideo = this.getAttribute('renderCoverVideo') === 'True';
    this._maxedOut = false;
    this.renderTemplate();
  }

  get sku() {
    return this._sku;
  }
  set sku(val) {
    this._sku = val;
  }

  get shippingDate() {
    var currentTime = new Date();
    var currentOffset = currentTime.getTimezoneOffset();
    var sellerOffset = (typeof(time_zone_offset) != 'undefined' && time_zone_offset != null) ? parseInt(time_zone_offset) : 330;
    var sellerTime = new Date(currentTime.getTime() + (sellerOffset + currentOffset) * 60000);
    var day = sellerTime.getDay();
    var s_string = ''
    if(this.inventory > 0){
      // HC shipping date
      // s_string = 'Ships in 4 days';
      this.shippingClass = 'slow';
      var cutOffTime = 16;
      if(this.seller === 'us'){
        cutOffTime = 15;
      }
      if(this.seller === 'gb'){
        cutOffTime = 15;
      }
      var sellerHours = sellerTime.getHours();
      var holiday = ( (day == 0 || day == 6 && seller == 'gb') || (day == 0 && seller == 'in') ) ? true : false;
      if (holiday){
        s_string = (day == 0) ? 'Ships tomorrow' : 'Ships on Monday';
        if (day != 0){
          this.shippingClass = 'slow';
        }
      }
      else {
        if (sellerHours >= 0 && sellerHours < 8) { // time between 12AM to 8AM
          s_string = "Ships today";
          this.shippingClass = 'quick';
        }
        else if (sellerHours >= 8 && sellerHours < cutOffTime) { // time between 8AM to cutOffTime
          let shipHours = 20 - sellerHours;
          s_string = "Ships in " + shipHours.toString() + " " + "hours";
          this.shippingClass = 'quick';
        }
        else if (sellerHours >= cutOffTime && sellerHours <= 24) { // time between cutOffTime to 12AM
          // Last day of week  - for india - saturday and for UK - friday  
          var last_day_of_week = ( (day == 5 && seller == 'gb') || (day == 6 && seller == 'in') ) ? true : false;
          if (last_day_of_week){
            s_string = "Ships on Monday";
            this.shippingClass = 'slow';
          }
          else{
            s_string = "Ships tomorrow";
            this.shippingClass = 'quick';
          }
        }
      }
      if(this.preorder == true || this.preorder == "True" || this.preorder == 'true'){
        s_string = this._shippingDate != '' ? `Ships on ${this._shippingDate}` : `Ships in a week`; // TODO: change to pre-order post sale
        this.shippingClass = 'slow';
        return s_string;
      }
      if(s_string !== ''){
        return s_string;
      }
    }
    this.shippingClass = 'slow';
    return this._shippingDate != '' ? `Ships on ${this._shippingDate}` : `Ships in a week`; // TODO: change to pre-order post sale
  }
  set shippingDate(val) {
    this._shippingDate = val;
  }

  get maxedOut() {
    return this._maxedOut;
  }
  set maxedOut(val) {
    this._maxedOut = val;
    if (this._maxedOut) {
      this.querySelector('a.button-add').classList.add('maxed-out');
      this.querySelector('a.button-add').style.display = 'none';
    }
    else {
      this.querySelector('a.button-add').classList.remove('maxed-out');
      this.querySelector('a.button-add').style.display = 'block';
    }
  }

  get available() {
    return this._available;
  }
  set available(val) {
    this._available = val;
    this.toggleAddButton();
  }

  get preorder() {
    return this._preorder;
  }
  set preorder(val) {
    this._preorder = val;
    this.updatePreorderStatus();
  }

  get finalSale() {
    return this._finalSale;
  }
  set finalSale(val) {
    this._finalSale = val;
    // this.updateFinalSale();
  }

  static get observedAttributes() {
    return ['available', 'sku'];
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    if (attr === 'available' || attr === 'sku') {
      this[attr] = newVal;
    }
  }

  toggleAddButton() {
    if (this.querySelector('a.button-add')) {
      if (this.available == 'true') {
        // if(this.classList.contains('soldout')){
        //   this.classList.remove('soldout');
        // }
        this.querySelector('a.button-add').style.display = 'block';
        this.querySelector('.soldout-tag').style.display = 'none';
      }
      else {
        // this.classList.add('soldout');
        this.querySelector('a.button-add').style.display = 'none';
        this.querySelector('.soldout-tag').style.display = 'block';
      }
    }
  }

  updatePreorderStatus() {
    let preorderTag = this.querySelector('.block .card .preorder-tag');
    if (preorderTag) {
      if (this.preorder) {
        preorderTag.innerHTML = this.shippingDate;
        preorderTag.style.display = 'inline'
      }
      else {
        preorderTag.style.display = 'none'
      }
    }
  }

  updateFinalSale() {
    let finalSaleTag = this.querySelector('.block .card .final-sale-tag');
    if (finalSaleTag) {
      if (this.finalSale == 'true') {
        finalSaleTag.style.display = 'inline';
      }
      else {
        finalSaleTag.style.display = 'none';
      }
    }
  }

  connectedCallback() {
    // Invoked each time the custom element is appended into DOM.

    // Update shipping class when component is connected
    this.updateShippingClass();

    if (this.renderCoverVideo) {
      const videoElement = this.querySelector('video');
      if (videoElement) {
        videoElement.poster = this.imgSrc1;
      }
    }

    if (this.querySelector('a.button-add')) {

      var productCard = this;
      // Attach add button to `Add to Cart`
      this.querySelector('a.button-add').addEventListener('click', (event => {
        event.preventDefault();
        productCard.querySelector('a.button-add').classList.add('add-check');
        let userCart = document.querySelector('user-cart');
        if (userCart) {
          userCart.cartAddingAnim();
          userCart.addToCart(1, productCard.sku);
          // Attach Cart handler to Reset the add button text
          userCart.addEventListener('cartUpdated', function (e) {
            setTimeout(() => {
              var addBtn = productCard.querySelector('a.button-add');
              if (addBtn) {
                addBtn.classList.remove('add-check');
              }
            }, 500)
          });
        }
      }));
    }
  }

  disconnectedCallback() {
    // Invoked each time the custom element is disconnected from the document's DOM.
  }

  renderTemplate() {
    // This is not Shadow DOM - can apply global css here.
    //  this.appendChild(cartTemplate.content.cloneNode(true));

    // const shadow = this.attachShadow({ mode: 'open' });
    // appending the container to the shadow DOM
    const productCardTemplate = document.createElement('template');
    productCardTemplate.innerHTML = `
      <div class="block">
        <div class="card" ${this.group} style="background:${this.background}">
          <div class="hero-wrapper">
            <a href="${this.shopUrl}" class="picture">
              <img src="${this.imgSrc1}" alt="" class="primary-image"/>
              <img src="${this.imgSrc2}" alt="" class="secondary-image"/>
            </a>
            <div class="add-button-wrapper absolute-block">
              <a href="#" class="button-add"></a>
              <div class="button block-button button-medium rounded soldout-tag">Sold Out</div>
            </div>
          </div>
          <p class="product-aside footnote absolute-block">
            ${this.finalSale === 'true' ? `
              <span class="final-sale-tag">Final Sale</span></p>` : ''
          }
          <div class="product-details">
            <div class="product-info">
              <p class="title footnote">${this.displayName}</p>
              <p class="footnote">${this.name}</p>
              <p class="footnote">
                <span class="preorder-tag quick slow">${this.shippingDate}</span>
              </p>
            </div>
            <div class="product-pricing">
              <p class="footnote">
                <span class="price discounted">${this.price}</span>
                ${this.strikeThrough === 'True' ? `
                  <span class="price original strikethrough">${this.fullprice}</span>` : ''
                }
              </p>
            </div>

        </div>
        <p class="new-tag caps pill absolute-block">New</p>
        </div>
      </div>
    `;
    this.appendChild(productCardTemplate.content.cloneNode(true));
  }

  get shippingClass() {
    console.log(this._shippingClass);
    return this._shippingClass || 'quick';
  }

  set shippingClass(val) {
    this._shippingClass = val;
    this.updateShippingClass();
  }

  updateShippingClass() {
    const preorderTag = this.querySelector('.preorder-tag');
    if (preorderTag) {
      preorderTag.classList.remove('quick', 'slow');
      preorderTag.classList.add(this._shippingClass || 'quick');
    }
  }

}
window.customElements.define('product-card', ProductCard);
